export const APPROVAL_STATE = {
  pending: "PENDING",
  approved: "APPROVED",
  standby: "STANDBY",
  autoApproved: "AUTO_APPROVED"
};
